import { render } from "./OrderDetail.vue?vue&type=template&id=5286bd26&scoped=true&ts=true"
import script from "./OrderDetail.vue?vue&type=script&lang=ts"
export * from "./OrderDetail.vue?vue&type=script&lang=ts"

import "./OrderDetail.vue?vue&type=style&index=0&id=5286bd26&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5286bd26"]])

export default __exports__